import React, { useEffect } from 'react'
import CommonNavbar from './CommonNavbar'
import Queryform from './Queryform'
import Footer from '../home/Footer'
import work from "../assets/rootimg/work.png";
import sampleImage from "../assets/rootimg/lover.png";
import bull from "../assets/rootimg/bull.png";

import rings from "../assets/rootimg/two-rings.png";
import dailyHoroscope from "../assets/rootimg/kundlicomp.png";
import dailytarotImage from "../assets/zodiacSign/dailytarot.png";
import { useLocation, useNavigate } from 'react-router';
import Navbar from '../home/Navbar';
const Compatiblity = () => {
  const navigate = useNavigate();
  const cardsclick = () => {
    navigate('/love/compatibility');
  }
  const cardsclick1 = () => {
    navigate('/work/compatibility');
  }
  const cardsclick2 = () => {
    navigate('/chinese/compatibility');
  }
  const kundliClick = () => {
    navigate('/kundlimatching');
  }
  const tarotClick = () => {
    navigate('/tarot');
  }
  const horoscopeClick = () => {
    navigate('/horoscope');
  }
  return (
    <>
      <section className='bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen'>
        <div>
          <Navbar />
        </div>
        <div className=" text-gray-900 flex flex-col items-center py-12">
          <h1 className="text-4xl text-secondary font-serif font-bold mb-2">COMPATIBILITY</h1>
          <p className="text-lg mb-12 text-secondary font-serif text-center max-w-2xl">
            Find out how your compatibility compares with your lover, friends, family, and more with our compatibility reading for all zodiac signs.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:ml-48 lg:mr-48  gap-6 px-4">
            {/* Work Compatibility */}
            <div onClick={cardsclick1} className="bg-blue-500 cursor-pointer font-primary shadow-md rounded-lg p-6 hover:shadow-custom-shadow text-center">
              <h2 className="text-xl font-bold font-serif text-white -mb-1">WORK</h2>
              <h2 className="text-xl font-serif font-bold text-white mb-2">COMPATIBILITY</h2>
              <img src={work} alt="Work Compatibility" className="w-24 h-24 mx-auto mb-4" />
              <p className="text-white lg:ml-6 lg:mr-6">
                Unlock the secrets of work compatibility through astrology, revealing how zodiac signs influence teamwork, problem-solving, and professional success.
              </p>
            </div>

            {/* Love Compatibility */}
            <div onClick={cardsclick} className="bg-pink-400 cursor-pointer shadow-md rounded-lg p-6 hover:shadow-custom-shadow text-center">
              <h2 className="text-xl font-serif font-bold text-white -mb-1">LOVE</h2>
              <h2 className="text-xl font-serif font-bold text-white mb-2">COMPATIBILITY</h2>
              <img src={sampleImage} alt="Love Compatibility" className="w-24 h-24 mx-auto mb-4" />
              <p className="text-white lg:ml-6 lg:mr-6">
                Discover how astrology shapes love compatibility, exploring the deep emotional connections, passions, and potential challenges between zodiac signs.
              </p>
            </div>

            {/* Chinese Compatibility */}
            <div onClick={cardsclick2} className="bg-success cursor-pointer shadow-md rounded-lg p-6 hover:shadow-custom-shadow text-center">
              <h2 className="text-xl font-serif font-bold text-white -mb-1">CHINESE</h2>
              <h2 className="text-xl font-serif font-bold text-white mb-2">COMPATIBILITY</h2>
              <img src={bull} alt="Chinese Compatibility" className="w-24 h-24 mx-auto mb-4" />
              <p className="text-white lg:ml-6 lg:mr-6">
                Discover Chinese astrology compatibility, where animal signs and elements reveal true harmony and challenges in relationships and life.
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center mt-10 text-center px-4 sm:px-6 md:px-8 lg:px-10 max-w-5xl">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900">
              About Compatibility
            </h3>
            <p className="text-sm sm:text-base text-justify mt-4 leading-relaxed">
              Astrological compatibility explores how celestial influences shape relationships in various aspects of life,
              including work, love, and friendships. By analyzing zodiac signs, planetary placements, and elements, astrology
              helps determine whether two individuals are naturally harmonious or face challenges in their interactions.
            </p>
            <p className="text-sm sm:text-base text-justify mt-2 leading-relaxed">
              <strong>Work compatibility</strong> focuses on how zodiac signs collaborate professionally, revealing strengths,
              communication styles, and leadership tendencies—Fire signs excel in leadership, Earth signs thrive in stability,
              Air signs bring innovation, and Water signs contribute emotional intelligence.
            </p>
            <p className="text-sm sm:text-base text-justify mt-2 leading-relaxed">
              <strong>Love compatibility</strong> examines the chemistry between partners, uncovering deep emotional connections,
              passion, and potential conflicts based on Sun, Moon, and Venus sign alignments.
            </p>
            <p className="text-sm sm:text-base text-justify mt-2 leading-relaxed">
              <strong>Chinese compatibility</strong>, based on the twelve animal signs and five elements (Wood, Fire, Earth, Metal, Water),
              provides insights into how personalities blend in relationships, friendships, and career partnerships.
            </p>
            <p className="text-sm sm:text-base text-justify mt-2 leading-relaxed">
              Whether exploring Western or Chinese astrology, compatibility readings offer guidance on fostering harmony, understanding
              differences, and creating meaningful connections.
            </p>
          </div>

        </div>
        <div className="mt-6 flex flex-col ml-4 sm:ml-8 md:ml-16 lg:ml-16 mr-4 sm:mr-8 md:mr-16 lg:mr-16 justify-center items-center">
          <h1 className="text-center text-lg sm:text-xl md:text-2xl text-secondary  font-bold">
            Recommended Reports For You
          </h1>
          {/* Parent Card div */}
          <div className="flex flex-wrap gap-5 justify-center mt-5">
            {/* Card 1 */}
            <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
              <div className="flex flex-col items-center">
                <img
                  src={rings}
                  alt="kundli.png"
                  className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-center text-secondary">Kundli Matching</h3>
                  <p className="text-justify text-xs sm:text-sm md:text-base m-3 mb-4">
                    Kundli Matching helps you find a match for your astrological traits and preferences. By comparing your birth
                    chart with others in the database, you can find a person who shares your similarities, characteristics, and
                    compatible energies.
                  </p>
                  <button
                    onClick={kundliClick}
                    className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                  >
                    Match Kundli
                  </button>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
              <div className="flex flex-col items-center">
                <img
                  src={dailytarotImage}
                  alt="daily-horoscope.png"
                  className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Tarot Rading</h3>
                  <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-6">
                    Tarot reading provides guidance by revealing hidden energies, emotions, and possibilities. By drawing cards
                    and interpreting meanings, you gain clarity on challenges, relationships, and opportunities. Each reading empowers
                    you to make informed decisions.

                  </p>
                  <button
                    onClick={tarotClick}
                    className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                  >
                    Start Reading
                  </button>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
              <div className="flex flex-col items-center">
                <img
                  src={dailyHoroscope}
                  alt="daily-horoscope.png"
                  className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Daily Horoscope</h3>
                  <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-6">
                    Get your personalized daily horoscope and insights for the day ahead. Stay prepared and make the
                    most of your day with astrological guidance to navigate challenges, seize opportunities, and align with cosmic energy.
                  </p>
                  <button
                    onClick={horoscopeClick}
                    className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                  >
                    View Horoscope
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div>
          <Queryform />
        </div>
        <div>
          <Footer />
        </div>

      </section>
    </>
  )
}

export default Compatiblity